import styled from "styled-components";
import { BodyText } from "@motain/web-shared-hub/ui/elements";

export const MessageText = styled(BodyText).withConfig({
  shouldForwardProp: () => true,
})`
  margin-top: 2.5rem;
  color: #fff;
  max-width: 24.5rem;
`;
